// InlineSelect — the house "quiet" native <select> for a control that sits
// INLINE in a row (the invite email row, the member rows, sharing
// permissions, the preview env picker): no field fill at rest, the row's
// own ink, sized to its longest option, and a fixed compact control height
// so no flex row can ever stretch it.
//
// UI-INVITE-MODAL-CONTROL-SIZE-1 (measured live on prod, 2026-09-07,
// lang=ka): the invite email row's role select painted 186×64. The recipe
// it carried at the call site (`padding: 'X Y2'`, `background: 'none'`,
// `color: 'currentColor'`, `width: 'auto'`, `flexShrink: '0'`) stated no
// height of its own, so the absolute overlay it sat in (`align-items:
// stretch`) grew it to the 62px send button beside it, and its label landed
// 13px under the input's text line. Rule 68: the control scale belongs to
// the primitive, never to the call site — and this was the FOURTH
// byte-identical copy of the recipe (MembersInInvite, InviteFormInDropdown,
// SharingPermissions, PreviewCanvasNavbar), which is where Rule 61 says it
// gets extracted. Host facts stay at the call site as MARGIN, never as
// padding: right-alignment (`margin-left: auto`) and the `-Y2` optical pull
// that lands the chevron on the host's scrollport edge.
export const InlineSelect = {
  extends: 'Select',
  // Quiet at rest: the row's ink, no field fill. The `field` theme the
  // Select atom carries still paints its hover/focus washes (Rule 65 — a
  // control acknowledges the pointer), which is why `theme` is NOT nulled.
  background: 'none',
  color: 'currentColor',
  // Brand control scale (§6.2): pinned fontSize, fixed-px height — the ONE
  // compact variant — and an em horizontal inset. `minHeight` alone leaves a
  // flex host's `align-items: stretch` free to grow the box; `alignSelf:
  // center` closes that door in every host.
  fontSize: 'Z2',
  minHeight: 'controlHCompact',
  padding: '0 Y2',
  round: 'radiusControl',
  alignSelf: 'center',
  // A control NEVER clips its own label (design-system call 2026-08-19,
  // fable.md "invite role select: the label clips at 87px"): intrinsic
  // width, no flex squeeze — the vocabulary is the vocabulary, in every
  // locale ("ადმინისტრატორი" is 186px at this size).
  width: 'auto',
  flexShrink: '0',
  cursor: 'pointer'
}
